import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { FileCopy } from '@mui/icons-material'
import { useHookstate } from '@hookstate/core'
import DispatchCopyDialog from './components/DispatchCopyDialog'
import { useLang } from '~/hooks/useLang'

interface DispatchCopyButtonProps {
  readonly canCopy: boolean | undefined
  readonly copyDispatch: (params: any) => Promise<void> | undefined
}

export default function DispatchCopyButton({
  ...props
}: DispatchCopyButtonProps) {
  const open = useHookstate(false)
  const { translate } = useLang()

  return (
    <Grid item>
      <Tooltip
        title={translate('Copiar Despacho')}
        placement="right-start"
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!props.canCopy} onClick={() => open.set(true)}>
            <FileCopy />
          </IconButton>
        </span>
      </Tooltip>
      {open.get() && (
        <DispatchCopyDialog open={open} copyDispatch={props.copyDispatch} />
      )}
    </Grid>
  )
}
